import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import { StyledCertificateModal, StyledPDFViewer } from "./PdfViewer.styled";
import { Button, ButtonSizes } from "../core/Button/Button";
import {
  NEXT_PAGE_LABLE,
  PREVIOUS_PAGE_LABLE,
} from "../../constants/Dictionary";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";
import { Loader } from "../core/Loader/Loader";
// Text layer & IntereactiveLink for React-PDF.
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

export const PDFViewer = ({
  file,
  title,
}: {
  file: ArrayBuffer;
  title?: string;
}) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setIsLoading(false);
  };

  const onDocumentLoadError = (error: { message: string }) => {
    setIsLoading(false);
    setError(error.message);
  };

  const goToNextPage = () =>
    setPageNumber((prev) => (prev < (numPages ?? 0) ? prev + 1 : prev));

  const goToPreviousPage = () =>
    setPageNumber((prev) => (prev > 1 ? prev - 1 : prev));

  return (
    <Loader loading={isLoading}>
      <StyledPDFViewer>
        {!isLoading && error ? (
          <div className="error">{error}</div>
        ) : (
          file && (
            <>
              <StyledCertificateModal title={title}>
                <div className="pdf-controls-wrapper">
                  <div className="pdf-page-controls">
                    <Button
                      size={ButtonSizes.SMALL}
                      label={PREVIOUS_PAGE_LABLE}
                      onClick={goToPreviousPage}
                      disabled={pageNumber === 1}
                    />
                    <Button
                      size={ButtonSizes.SMALL}
                      label={NEXT_PAGE_LABLE}
                      onClick={goToNextPage}
                      disabled={pageNumber === numPages}
                    />
                  </div>
                  <div className="pdf-page-indicator">
                    <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD}>
                      Pagina {pageNumber} di {numPages}
                    </BodyTyp>
                  </div>
                </div>
                <div className="pdf-document-container">
                  <Document
                    file={file}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={onDocumentLoadError}
                  >
                    <Page pageNumber={pageNumber} />
                  </Document>
                </div>
              </StyledCertificateModal>
            </>
          )
        )}
      </StyledPDFViewer>
    </Loader>
  );
};
